import React from 'react';
import { TMenuContentVersion } from 'types';
import FormInput from 'components/Input/FormInput';

interface IMenuVersionField {
	changeMenuVersion: (value: string) => void;
	useMenuVersion: TMenuContentVersion;
}

const MenuVersionField: React.FC<IMenuVersionField> = ({ changeMenuVersion, useMenuVersion }) => {
	// const handleChange = useCallback(
	// 	(e: React.ChangeEvent<HTMLInputElement>) => {
	// 		e.target.maxLength = 10;
	// 		const onlyDigits = e.target.value.replace(/\D/g, '');
	// 		const validValue = onlyDigits.replace(/^(\d{8})(\d)/, '$1-$2');
	// 		changeMenuVersion(validValue);
	// 		return validValue;
	// 	},
	// 	[changeMenuVersion],
	// );

	return (
		<FormInput
			testId="MenuVersionField"
			name="restaurantMenuVersion"
			label="menuVersionLabel"
			placeholder="menuVersionPlaceholder"
			// getValueFromEvent={handleChange}
			onChange={changeMenuVersion}
			disabled={useMenuVersion === 'Customer'}
		/>
	);
};

export default React.memo(MenuVersionField);
